import {GridMinmax} from '../types/GridMinmax';
import {GridRepeat} from '../types/GridRepeat';
import {GridTrackBreadth} from '../types/GridTrackBreadth';
import {Integer} from '../types/Integer';
import {getGridTrackSize} from './getGridTrackSize';

/**
 * @about CSS `repeat()` track. Integers in the track are design-system steps.
 * @example gridRepeat(7, gridMinmax(25, '1fr'))
 */
export function gridRepeat(
  count: Exclude<Integer, 0>,
  track: GridTrackBreadth | GridMinmax
): GridRepeat {
  return {repeat: `repeat(${count}, ${getGridTrackSize(track)})`};
}
